module.exports = __webpack_public_path__ + "static/media/racion.4dc04c93.png";